export const SELECT_KIKAN_TABS = {
  "K002": ['1日', '週間', '月間', '年間'],
  "K003": ['1日', '週間', '月間', '年間'],
  "K004": ['1日', '週間', '月間', '年間'],
  "K005": ['1日', '週間', '月間', '年間'],
  "K006": ['1日', '週間', '月間', '年間'],
  "K007": ['1日', '週間', '月間'],
  "K008": ['1日', '週間', '月間'],
  "K009": ['1日', '週間', '月間'],
  "K010": ['1日', '週間', '月間'],
  "K011": ['1日', '週間', '月間'],
  "K012": [],
  "K013": ['1日', '週間', '月間', '全期間'],
  "K014": ['1日', '週間', '月間'],
  "K015": ['1日', '週間', '月間']
};

export default SELECT_KIKAN_TABS;
